export default __webpack_public_path__ + "static/embedded-software-a506367645c62a9dcee648bd5e732b65.webp";